module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.b9d01ac1742192a7c9d3.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Medium-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.woff
// module chunks = styles